import { useEffect } from 'react';

export default function useFieldValidate(validateField, watchValue) {
  useEffect(() => {
    validateField(watchValue)
  }, [watchValue, validateField])
}